export enum STREAM_BUTTON_DISPLAY_TYPE {
  SMALL = 'small',
  REGULAR = 'regular',
}

export enum STREAMING_SUPPLIER {
  BETRADAR = 'Betradar',
  BETMAKERS = 'Betmakers',
  UNDEFINED = 'N/A',
}
